var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-email-confirmation",class:{ 'auth-email-confirmation_error': !!_vm.error }},[_vm._v("\n  "+_vm._s(!!_vm.error ? _vm.error : _vm.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }